import React, { useState, useEffect } from 'react';
import { ScrollView, View, StyleSheet } from 'react-native';
import { Text, Card } from '@rneui/themed';
import { useAuth } from '../config/AuthContext';
import { useRoute } from '@react-navigation/native';
import config from '../config/config';

export function LoteScreen() {
  const route = useRoute();
  const { deviceName } = route.params;
  // const azureUrl = 'http://localhost:3001/api';
  const tableName = 'equipstates';
  const { maquinaId } = useAuth();

  const [lote, setLote] = useState({});
  const [loteId, setLoteId] = useState({});
  const [loteIni, setLoteIni] = useState({});
  const [loteNome, setLoteNome] = useState({});
  const [lotePdt, setLotePdt] = useState({});
  const [loteOpr, setLoteOpr] = useState({});
  const [loteFrn, setLoteFrn] = useState({});
  const [loteMad, setLoteMad] = useState({});

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 5000);
    return () => clearInterval(interval);
  }, []);

  async function fetchData() {
    try {
      const tabelaEndpoint = `${config.apiBaseUrl}/tables/${tableName}?$filter=maquinaId eq '${maquinaId}'`;
      const response = await fetch(tabelaEndpoint, {
        headers: {
          'ZUMO-API-VERSION': '2.0.0',
        },
      });
      const data = await response.json();
      const parsedData = JSON.parse(data[0].dados);

      const loteId = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.LoteId);
      setLoteId(loteId);

      const loteIni = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.LoteIni);
      setLoteIni(loteIni);

      const lote = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.Lote);
      setLote(lote);

      const lotePdt = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.LotePdt);
      setLotePdt(lotePdt);

      const loteOpr = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.LoteOpr);
      setLoteOpr(loteOpr);

      const loteFrn = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.LoteFrn);
      setLoteFrn(loteFrn);

      const loteMad = parsedData
        .filter((item) => item.Nome === deviceName)
        .map((item) => item.LoteMad);
      setLoteMad(loteMad);
    } catch (error) {
      console.log(`Erro ao listar dados: ${error.message}`);
    }
  }

  return (
    <ScrollView contentContainerStyle={styles.scrollContainer}>
      <Card containerStyle={styles.cardContainer}>
        <Text style={styles.title}>{loteId[0]}</Text>
        <Text style={{ fontSize: 20 }}>{loteIni[0]}</Text>
      </Card>

      <Card containerStyle={styles.cardContainer}>
        <Text style={styles.title}>- Lote -</Text>
        <Text style={{ fontSize: 17 }}>{lote[0]}</Text>
      </Card>

      <Card containerStyle={styles.cardContainer}>
        <Text style={styles.title}>- Produto -</Text>
        <Text style={{ fontSize: 17 }}>{lotePdt[0]}</Text>
      </Card>

      <Card containerStyle={styles.cardContainer}>
        <Text style={styles.title}>- Operador -</Text>
        <Text style={{ fontSize: 17 }}>{loteOpr[0]}</Text>
      </Card>

      <Card containerStyle={styles.cardContainer}>
        <Text style={styles.title}>- Fornecedor -</Text>
        <Text style={{ fontSize: 17 }}>{loteFrn[0]}</Text>
      </Card>

      <Card containerStyle={styles.cardContainer}>
        <Text style={styles.title}>- Madeira -</Text>
        <Text style={{ fontSize: 17 }}>{loteMad[0]}</Text>
      </Card>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollContainer: {
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 20,
    backgroundColor: '#CCCCCA',
  },
  cardContainer: {
    backgroundColor: '#F3F3F1',
    width: 250,
    height: 70,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    elevation: 5,
    marginBottom: 10,
  },
  title: {
    textAlign: 'center',
    fontSize: 18,
    color: '#0081CF',
    padding: 5,
  },
});
